import { BACKEND_DATE_FORMAT } from 'constants/date';

import dayjs from 'dayjs';

export const getBirthdayByAge = (age: number): string => {
    const birthYear = new Date().getFullYear() - age;

    return getFormattedDate(`${birthYear}-01-01`, 'YYYY-MM-DD HH:mm:ss');
};

export const getAgeFromBirthday = (birthday: string | null): number => {
    if (!birthday) return 0;

    const today = new Date();
    const todayYear = today.getFullYear();
    const yearOfBirth = birthday.split('-')[0];

    return todayYear - Number(yearOfBirth);
};

export const getFormattedDate = (date: string, format: string): string => {
    return dayjs(date).format(format);
};

export const compareDates = (date1: string, date2: string) => dayjs(date1).diff(dayjs(date2));

export const getToday = (format: string = BACKEND_DATE_FORMAT) => dayjs().format(format);

export const formatSecondsToFullTime = (time: number): string => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    const formattedMinutes = String(minutes).padStart(2, '0');
    const formattedSeconds = String(seconds).padStart(2, '0');

    return `${formattedMinutes}:${formattedSeconds}`;
};

export const toYYMMDD = (s?: string | null): string | null => {
    if (!s || s.length < 10) return null;
    if (s[4] !== '-' || s[7] !== '-') return null;

    return s.slice(2, 4) + s.slice(5, 7) + s.slice(8, 10);
};
